// TextTeamNameAndSettings

const goToEditNameSettings = (state) => {
  return {
    ...state,
    editSettingsStatus: "edit"
  }
}

export default goToEditNameSettings